var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMainList,
              expression: "showMainList"
            }
          ],
          staticClass: "main-content",
          attrs: { type: "primary" }
        },
        [
          _c(
            "div",
            {
              staticClass: "cargo-advance-search share-search",
              staticStyle: { height: "auto", width: "100%" }
            },
            [
              _c(
                "div",
                {
                  ref: "searchOperations",
                  staticClass: "cargo-advance-search-operations",
                  staticStyle: { "margin-top": "10px", "margin-bottom": "10px" }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "inline-block",
                        "margin-right": "5px"
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("Pricing.ShareState")))
                      ]),
                      _c(
                        "el-select",
                        {
                          attrs: { no: "shareState" },
                          model: {
                            value: _vm.shareState,
                            callback: function($$v) {
                              _vm.shareState = $$v
                            },
                            expression: "shareState"
                          }
                        },
                        _vm._l(_vm.shareStates, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "onQuery", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.onQuery()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.Query")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isActiveCpTab,
                          expression: "isActiveCpTab"
                        }
                      ],
                      attrs: { no: "onAddShare", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.onAddShare()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.Add")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isActiveCpTab,
                          expression: "isActiveCpTab"
                        }
                      ],
                      attrs: {
                        no: "onEdit",
                        type: "primary",
                        disabled: !_vm.cpSelectRow
                      },
                      on: {
                        click: function($event) {
                          return _vm.onEdit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.Edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isActiveCpTab,
                          expression: "!isActiveCpTab"
                        }
                      ],
                      attrs: {
                        no: "onAcceptShare",
                        type: "primary",
                        disabled: !(
                          _vm.ppSelectRow != null &&
                          !_vm.ppSelectRow.active &&
                          !_vm.ppSelectRow.applyFor
                        )
                      },
                      on: {
                        click: function($event) {
                          return _vm.onAcceptShare()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.Accept")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isActiveCpTab,
                          expression: "isActiveCpTab"
                        }
                      ],
                      attrs: {
                        no: "onAgree",
                        disabled: !(
                          _vm.cpSelectRow != null &&
                          _vm.cpSelectRow.applyFor &&
                          (_vm.cpSelectRow.checkState === 0 ||
                            _vm.cpSelectRow.checkState === 3)
                        ),
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onAgree()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.Agree")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isActiveCpTab,
                          expression: "isActiveCpTab"
                        }
                      ],
                      attrs: {
                        no: "onRefuse",
                        disabled: !(
                          _vm.cpSelectRow != null &&
                          _vm.cpSelectRow.applyFor &&
                          (_vm.cpSelectRow.checkState === 0 ||
                            _vm.cpSelectRow.checkState === 3)
                        ),
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onRefuse()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.Refuse")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isActiveCpTab,
                          expression: "isActiveCpTab"
                        }
                      ],
                      attrs: {
                        no: "onCancel",
                        disabled: !(
                          _vm.cpSelectRow != null &&
                          _vm.cpSelectRow.applyFor &&
                          _vm.cpSelectRow.checkState === 1
                        ),
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.cancleAgree()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.CancelAgree")))]
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              ref: "tabs",
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("Pricing.AuthInvite2"),
                    name: "cpList"
                  }
                },
                [
                  _c("div", { staticClass: "grid-view" }, [
                    _c("div", { staticClass: "main-content" }, [
                      _c(
                        "div",
                        { staticClass: "section grid-wrapper" },
                        [
                          _c("cargo-ag-grid", {
                            attrs: {
                              "v-if": _vm.activeTabName === "cpList",
                              "config-module": "221601",
                              "show-approve": true,
                              "row-data": _vm.rowCpData,
                              "grid-options": _vm.cpGridOptions,
                              "column-defs": _vm.inviteColumnDefs
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ]
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("Pricing.AuthAccept2"),
                    name: "ppList"
                  }
                },
                [
                  _c("cargo-ag-grid", {
                    attrs: {
                      "v-if": _vm.activeTabName === "ppList",
                      "config-module": "221602",
                      "show-approve": false,
                      "show-selection": true,
                      "row-data": _vm.rowPpData,
                      "grid-options": _vm.ppGridOptions,
                      "column-defs": _vm.acceptColumnDefs
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.formDialog.visible,
            title: _vm.$t("Price.FullContainerFreightSharingDetails"),
            width: "400px",
            "close-on-click-modal": false,
            "destroy-on-close": true,
            top: "5vh",
            "custom-class": "details-view fcl-addon-form"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.formDialog, "visible", $event)
            }
          }
        },
        [
          _c("div", { staticClass: "main-content" }, [
            _c(
              "div",
              { staticStyle: { "margin-bottom": "10px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { no: "onSave", type: "primary" },
                    on: { click: _vm.onSave }
                  },
                  [_vm._v(_vm._s(_vm.$t("Pricing.Save")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { no: "cancel" },
                    on: {
                      click: function($event) {
                        _vm.formDialog.visible = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("Pricing.Cancel")))]
                )
              ],
              1
            ),
            _c("div", { staticStyle: { width: "fit-content" } }, [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c(
                  "div",
                  {
                    staticClass: "section form-column",
                    staticStyle: { width: "380px !important" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-width": "120px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Pricing.IWantShare") } },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "acceptTenant",
                                disabled: !_vm.formDialog.isShareTo,
                                "select-type": _vm.selectTypeNames.TENANT,
                                cache: false,
                                filterable: "",
                                "custom-label": function(item) {
                                  return "[" + item.id + "]" + item.name
                                },
                                "callback-method-type": "obj",
                                "default-value":
                                  String(
                                    _vm.formDialog.tenantShare.acceptTenant
                                  ) || ""
                              },
                              on: { parentCallBack: _vm.changeTenant }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.needMarkup,
                                expression: "needMarkup"
                              }
                            ],
                            attrs: { label: _vm.$t("Pricing.AllowedTier") }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { no: "point" },
                                model: {
                                  value: _vm.formDialog.tenantShare.point,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formDialog.tenantShare,
                                      "point",
                                      $$v
                                    )
                                  },
                                  expression: "formDialog.tenantShare.point"
                                }
                              },
                              _vm._l(_vm.tiers, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm.priceSharing === "PriceFclSharing"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("Pricing.SharingProfile")
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        no: "tenantSharingPriceProfileName",
                                        disabled: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formDialog
                                            .tenantSharingPriceProfileName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formDialog,
                                            "tenantSharingPriceProfileName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formDialog.tenantSharingPriceProfileName"
                                      }
                                    }),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { no: "showProfile" },
                                        on: {
                                          click: function($event) {
                                            return _vm.showProfile(false)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Pricing.SelectProfile")
                                          )
                                        )
                                      ]
                                    ),
                                    this.tenantSharingPriceProfileDialog.isEdit
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { no: "resetProfile" },
                                            on: { click: _vm.resetProfile }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("SeaExport.Reset"))
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Pricing.ShareRemark") } },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      display: "inline-block"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("Pricing.ShareRemark")) +
                                        " "
                                    )
                                  ]
                                ),
                                _c(
                                  "span",
                                  { staticStyle: { color: "#ff0000" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("Pricing.ShareRemarks")) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _c("el-input", {
                              attrs: {
                                no: "remarks",
                                type: "textarea",
                                maxlength: 255
                              },
                              model: {
                                value: _vm.formDialog.tenantShare.remarks,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formDialog.tenantShare,
                                    "remarks",
                                    $$v
                                  )
                                },
                                expression: "formDialog.tenantShare.remarks"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.applyDialog.visible,
            "close-on-click-modal": false,
            title: _vm.applyDialog.isAccept
              ? _vm.$t("Pricing.Agree")
              : _vm.$t("Pricing.Refuse"),
            width: "400px",
            top: "5vh",
            "custom-class": "details-view fcl-addon-form"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.applyDialog, "visible", $event)
            }
          }
        },
        [
          _c("div", { staticClass: "main-content" }, [
            _c("div", { staticStyle: { width: "fit-content" } }, [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c(
                  "div",
                  {
                    staticClass: "section form-column",
                    staticStyle: { width: "380px !important" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-width": "120px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Pricing.WantApply") } },
                          [
                            _c("el-input", {
                              attrs: {
                                no: "wantApply",
                                value:
                                  _vm.applyDialog.tenantShare.acceptTenant +
                                  " " +
                                  _vm.applyDialog.tenantShare.acceptTenantName,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.applyDialog.isAccept,
                                expression: "applyDialog.isAccept"
                              }
                            ],
                            attrs: { label: _vm.$t("Pricing.AllowedTier") }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { no: "allowedTier" },
                                model: {
                                  value: _vm.applyDialog.tenantShare.point,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.applyDialog.tenantShare,
                                      "point",
                                      $$v
                                    )
                                  },
                                  expression: "applyDialog.tenantShare.point"
                                }
                              },
                              _vm._l(_vm.tiers, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm.priceSharing === "PriceFclSharing" &&
                        _vm.applyDialog.isAccept
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("Pricing.SharingProfile")
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        no: "tenantSharingPriceProfileName",
                                        disabled: ""
                                      },
                                      model: {
                                        value:
                                          _vm.applyDialog
                                            .tenantSharingPriceProfileName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.applyDialog,
                                            "tenantSharingPriceProfileName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "applyDialog.tenantSharingPriceProfileName"
                                      }
                                    }),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { no: "selectProfile" },
                                        on: {
                                          click: function($event) {
                                            return _vm.showProfile(true)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Pricing.SelectProfile")
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { no: "reset" },
                                        on: { click: _vm.resetProfile }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Reset"))
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.applyDialog.isAccept,
                                expression: "applyDialog.isAccept"
                              }
                            ],
                            attrs: { label: _vm.$t("Pricing.ShareRemark") }
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      display: "inline-block"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("Pricing.ShareRemark")) +
                                        " "
                                    )
                                  ]
                                ),
                                _c(
                                  "span",
                                  { staticStyle: { color: "#ff0000" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("Pricing.ShareRemarks")) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _c("el-input", {
                              attrs: {
                                no: "tenantShareRemarks",
                                type: "textarea",
                                maxlength: 255
                              },
                              model: {
                                value: _vm.formDialog.tenantShare.remarks,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formDialog.tenantShare,
                                    "remarks",
                                    $$v
                                  )
                                },
                                expression: "formDialog.tenantShare.remarks"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.applyDialog.isAccept,
                                expression: "!applyDialog.isAccept"
                              }
                            ],
                            attrs: { label: _vm.$t("Pricing.RefuseRemark") }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                no: "applyDialogRemarks",
                                type: "textarea",
                                maxlength: 255
                              },
                              model: {
                                value: _vm.applyDialog.tenantShare.remarks,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.applyDialog.tenantShare,
                                    "remarks",
                                    $$v
                                  )
                                },
                                expression: "applyDialog.tenantShare.remarks"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          ]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "commitHandler", type: "primary" },
                  on: { click: _vm.commitHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "applyDialogClose" },
                  on: {
                    click: function($event) {
                      _vm.applyDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.tenantSharingPriceProfileDialog.visible,
            title: _vm.$t("Pricing.PriceProfile"),
            width: "800px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(
                _vm.tenantSharingPriceProfileDialog,
                "visible",
                $event
              )
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: {
              width: "100%",
              "min-height": "150px",
              "margin-top": "20px"
            },
            attrs: {
              "grid-params": _vm.tenantSharingPriceProfileDialog.gridParams,
              "grid-options": _vm.tenantSharingPriceProfileDialog.gridOptions,
              "column-defs": _vm.tenantSharingPriceProfileDialog.columnDefs,
              "row-data": _vm.tenantSharingPriceProfileDialog.rowData,
              "auto-fit-content": false
            },
            on: {
              "update:gridParams": function($event) {
                return _vm.$set(
                  _vm.tenantSharingPriceProfileDialog,
                  "gridParams",
                  $event
                )
              },
              "update:grid-params": function($event) {
                return _vm.$set(
                  _vm.tenantSharingPriceProfileDialog,
                  "gridParams",
                  $event
                )
              }
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tenantSharingPriceProfileDialog.isEdit,
                      expression: "tenantSharingPriceProfileDialog.isEdit"
                    }
                  ],
                  attrs: { no: "profileDialogConfirm" },
                  on: { click: _vm.confirmProfile }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "profileDialogClose" },
                  on: {
                    click: function($event) {
                      _vm.tenantSharingPriceProfileDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }